// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPopUp_wrapper__196pw","products":"SearchPopUp_products__ha4eN"};